import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MenuController } from '@ionic/angular/lazy';
import * as fromUser from '@app/lib/b2b-stores/user';
import { Store } from '@ngrx/store';
import * as fromRoot from '@app/lib/b2b-stores';
import { LoggerService } from '@app/lib/b2b-services/util/logger.service';
import { RouterUtilService } from '@app/lib/b2b-services/util/router-util.service';
import { NavigationModel } from '@app/models/client-models/navigation/navigation.model';

@Component({
  selector: 'b2b-vertical-navigation',
  templateUrl: './vertical-navigation.component.html',
  styleUrls: ['./vertical-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VerticalNavigationComponent implements OnInit {
  // navigations: NavigationModel[] = [];
  // urlPath: string;

  constructor(
    private menuController: MenuController,
    private store: Store<fromRoot.State>,
    public routerUtilService: RouterUtilService,
  ) {}

  ngOnInit() {
    // this.createNavigations();
  }

  togglePage() {
    this.menuController.close().then();
  }

  logout() {
    this.store.dispatch(fromUser.SignOut({}));
  }

  onAccordionGroupChange(event: any, navigation: NavigationModel) {
    LoggerService.log('event ', event?.detail?.value);
    if (event?.detail?.value) {
      for (const nav of this.routerUtilService?.navigations) {
        if (nav?.id === navigation?.id) {
          nav.active = true;
        } else {
          nav.active = false;
        }
      }
    }
  }
}
